import { module } from 'modujs';
import { AddressForm } from '@shopify/theme-addresses';

export default class extends module {
    constructor(m) {
        super(m);

        // UI
        this.$el = this.el
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.addressForm = AddressForm(this.$('form-wrapper-inner')[0], this.getData('lang'))
    }

    destroy() {
        super.destroy();
    }

    ///////////////
    // Methods
    ///////////////
}
